// // src/App.js
// import React from 'react';
// import { motion } from 'framer-motion';
// import { Link } from 'react-scroll';
// import styled from 'styled-components';
// import { FaLinkedin, FaEnvelope, FaPhone, FaArrowUp } from 'react-icons/fa';
// import Header from './components/Header';
// import Hero from './components/Hero';
// import Mission from './components/Mission';
// import About from './components/About';
// import Services from './components/Services';
// import Process from './components/Process';
// import Testimonials from './components/Testimonials';
// import Booking from './components/Booking';
// import Contact from './components/Contact';
// import Footer from './components/Footer';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <Header />
//       <main>
//         <Hero />
//         <Mission />
//         <About />
//         <Services />
//         <Process />
//         <Testimonials />
//         <Booking />
//         <Contact />
//       </main>
//       <BackToTop>
//         <Link to="top" smooth={true} duration={800}>
//           <FaArrowUp />
//         </Link>
//       </BackToTop>
//       <Footer />
//     </div>
//   );
// }

// const BackToTop = styled.div`
//   position: fixed;
//   bottom: 40px;
//   right: 40px;
//   background: #5A7F8C;
//   color: white;
//   width: 50px;
//   height: 50px;
//   border-radius: 50%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   cursor: pointer;
//   box-shadow: 0 4px 10px rgba(0,0,0,0.1);
//   transition: all 0.3s ease;
  
//   &:hover {
//     transform: translateY(-5px);
//     box-shadow: 0 6px 15px rgba(0,0,0,0.15);
//   }
// `;

// export default App;

// src/App.js
import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-scroll';
import styled from 'styled-components';
import { FaLinkedin, FaEnvelope, FaPhone, FaArrowUp } from 'react-icons/fa';
import Header from './components/Header';
import Hero from './components/Hero';
import Mission from './components/Mission';
import About from './components/About';
import Services from './components/Services';
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import Booking from './components/Booking';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PersonalJourney from './pages/PersonalJourney'; // Add this import
import './App.css';

function App() {
  // Simple routing check
  if (window.location.pathname === '/my-journey') {
    return <PersonalJourney />;
  }

  // Otherwise, show the main site
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Mission />
        <About />
        <Services />
        <Process />
        <Testimonials />
        <Booking />
        <Contact />
      </main>
      <BackToTop>
        <Link to="top" smooth={true} duration={800}>
          <FaArrowUp />
        </Link>
      </BackToTop>
      <Footer />
    </div>
  );
}

const BackToTop = styled.div`
  position: fixed;
  bottom: 40px;
  right: 40px;
  background: #5A7F8C;
  color: white;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 15px rgba(0,0,0,0.15);
  }
`;

export default App;